<template>
    <main>
        <Nav></Nav>

        <SectionMain></SectionMain>

        <Section01 :dotted-lines-h="dottedLinesH"
                   :dotted-lines-v="dottedLinesV"
                   :s01-bg1="s01Bg1"
                   :s01-bg2="s01Bg2"></Section01>

        <Section02 :blue-box="blueBox"
                   :s02-bg1="s02Bg1"
                   :s02-bg2="s02Bg2"
                   :s02-bg3="s02Bg3"></Section02>

        <Section03 :s03-bg1="s03Bg1"
                   :s03-bg2="s03Bg2"
                   :s03-bg3="s03Bg3"></Section03>

        <Section04 :blue-box="blueBox"
                   :s04-bg1="s04Bg1"
                   :s04-bg2="s04Bg2"
                   :s04-bg3="s04Bg3"></Section04>

        <Section05 :s05-bg1="s05Bg1"
                   :s05-bg2="s05Bg2"
                   :s07-bg3="s07Bg3"></Section05>

       <Section06 :blue-box="blueBox"
                  :s06-bg1="s06Bg1"
                  :s06-bg2="s06Bg2"></Section06>

       <Section07 :s07-bg1="s07Bg1"
                  :s07-bg2="s07Bg2"
                  :s07-bg3="s07Bg3"></Section07>

       <Section08 :blue-box="blueBox"
                  :s01-bg1="s01Bg1"></Section08>

        <Footer></Footer>
    </main>
</template>

<script>
import blueBox from '@/assets/img/blue-box.png'
import dottedLinesV from '@/assets/img/dotted-lines-v.png'
import dottedLinesH from '@/assets/img/dotted-lines-h.png'
import s01Bg1 from '@/assets/img/s01-bg1.png'
import s01Bg2 from '@/assets/img/s01-bg2.png'
import s02Bg1 from '@/assets/img/s02-bg1.png'
import s02Bg2 from '@/assets/img/s02-bg2.png'
import s02Bg3 from '@/assets/img/s02-bg3.png'
import s03Bg1 from '@/assets/img/s03-bg1.jpg'
import s03Bg2 from '@/assets/img/s03-bg2.png'
import s03Bg3 from '@/assets/img/s03-bg3.png'
import s04Bg1 from '@/assets/img/s04-bg1.jpg'
import s04Bg2 from '@/assets/img/s04-bg2.png'
import s04Bg3 from '@/assets/img/s04-bg3.png'
import s05Bg1 from '@/assets/img/s05-bg1.jpg'
import s05Bg2 from '@/assets/img/s05-bg2.png'
import s05Bg3 from '@/assets/img/s05-bg3.png'
import s06Bg1 from '@/assets/img/s06-bg1.jpg'
import s06Bg2 from '@/assets/img/s06-bg2.png'
import s07Bg1 from '@/assets/img/s07-bg1.jpg'
import s07Bg2 from '@/assets/img/s07-bg2.png'
import s07Bg3 from '@/assets/img/s07-bg3.png'
import Nav from './Nav'
import SectionMain from './SectionMain'
import Section01 from './Section-01'
import Section02 from './Section-02'
import Section04 from './Section-04'
import Section03 from './Section-03'
import Section05 from './Section-05'
import Section06 from './Section-06'
import Section07 from './Section-07'
import Section08 from './Section-08'
import Footer from './Footer'

export default {
  name: 'HelloWorld',
  components: {
    Nav,
    Footer,
    Section08,
    Section07,
    Section06,
    Section05,
    Section03,
    Section04,
    Section02,
    Section01,
    SectionMain },
  props: {
  },
  data () {
    return {
      blueBox: blueBox,
      dottedLinesV: dottedLinesV,
      dottedLinesH: dottedLinesH,
      s01Bg1: s01Bg1,
      s01Bg2: s01Bg2,
      s02Bg1: s02Bg1,
      s02Bg2: s02Bg2,
      s02Bg3: s02Bg3,
      s03Bg1: s03Bg1,
      s03Bg2: s03Bg2,
      s03Bg3: s03Bg3,
      s04Bg1: s04Bg1,
      s04Bg2: s04Bg2,
      s04Bg3: s04Bg3,
      s05Bg1: s05Bg1,
      s05Bg2: s05Bg2,
      s05Bg3: s05Bg3,
      s06Bg1: s06Bg1,
      s06Bg2: s06Bg2,
      s07Bg1: s07Bg1,
      s07Bg2: s07Bg2,
      s07Bg3: s07Bg3
    }
  },
  methods: {

  }
}
</script>
